import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicFacade } from '../../store/dynamic.facade';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Presentation } from '../../models/presentation.models';
import {
    // ...existing code...
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';

@Component({
  standalone: false,
    selector: 'app-presentation-view',
    templateUrl: './presentation-view.component.html',
    styleUrls: ['./presentation-view.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({
                    transform: 'translateX(100%)'
                }),
                animate('500ms ease-out',
                    style({
                        transform: 'translateX(0%)'
                    }))
            ])
        ])
    ]
})
export class PresentationViewComponent implements OnInit {

    private presentation$: Observable<Presentation> = this.dynamicFacade.presentation$;
    private currentUiDefinitionName = new BehaviorSubject<string>('');
    private currentItemIndex = 0;
    animationState = true;

    constructor(
        private dynamicFacade: DynamicFacade,
        private router: Router) {
    }

    ngOnInit(): void {
        this.presentation$.subscribe(presentation => {
            if (presentation && presentation.process.length > 0) {
                this.showCurrentItem(presentation);
            }
        });
        var urlSplit = this.router.url.split('/');
        var lastSegment = urlSplit[urlSplit.length - 1];
        this.dynamicFacade.GetPresentation(lastSegment);
    }

    private moveToNextItem(presentation: Presentation): void {
        if (!presentation) return;
        this.currentItemIndex++;
        if (this.currentItemIndex >= presentation.process.length) {
            this.currentItemIndex = 0; // Optional: loop back to start
            // Seite refreshen
            window.location.reload();

        }
        this.showCurrentItem(presentation);
    }

    private showCurrentItem(presentation: Presentation) {
        const currentItem = presentation.process[this.currentItemIndex];
        this.currentUiDefinitionName.next(currentItem.uiDefinition);

        for (const sessionVar of currentItem.sessionVariables || []) {
            this.dynamicFacade.SetData("session", sessionVar.name, ".", [], sessionVar.value, "");
        }

        this.dynamicFacade.GetUiDefinitionFromName(this.currentUiDefinitionName.value, "", "", "");
        this.fadeIn()

        if (currentItem.timerInSeconds) {
            setTimeout(() => {
                this.moveToNextItem(presentation);
            }, currentItem.timerInSeconds * 1000);
        }
    }

    fadeIn() {
        this.animationState = false;
        setTimeout(() => {
            this.animationState = true;
        }, 1);
    }

}

